export default function autoFocus($timeout) {
  'ngInject'
  var directive = {
    restrict: 'AC',
    link: focusLink,
  }

  return directive

  function focusLink(scope, element) {
    $timeout(function() {
      element[0].focus()
    }, 1000)
  }
}
